import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        ngId: '=',
        options: '=',
        class: '@',
        ngModel: '=',
        ngChange: '&',
        ngDisabled: '='
    },
    template
})
export default class {
    constructor ($timeout, $scope, moment) {
        $scope.$watch('vm.ngModel', () => {
            this.dateModel = this.ngModel ? moment(this.ngModel, 'YYYY-MM-DD').toDate() : undefined;
        });
        this.onDateChange = () => {
            $timeout(() => {
                this.ngModel = this.dateModel ? moment(this.dateModel).format('YYYY-MM-DD') : null;
                if (this.ngChange) {
                    this.ngChange();
                }
            });
        };

        $scope.$on(`clear:datepicker:${this.ngId}`, () => {
            this.dateModel = this.ngModel = null;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/datepicker/api/index.js